import React from 'react';
import { motion } from 'framer-motion';
import { ArrowDownIcon, CheckIcon, XIcon } from 'lucide-react';
const rows = [{
  before: 'No saber cómo romper un silencio incómodo.',
  after: 'Tener siempre una pregunta lista para desbloquear la conversación.'
}, {
  before: 'Improvisar mientras el paciente espera.',
  after: 'Conducir cada sesión con claridad y seguridad.'
}, {
  before: 'Hacer preguntas genéricas que generan respuestas superficiales.',
  after: 'Formular preguntas estratégicas que llevan al origen del problema.'
}, {
  before: 'Sentir inseguridad con pacientes difíciles o resistentes.',
  after: 'Contar con herramientas específicas para cada tipo de paciente.'
}, {
  before: 'Terminar la sesión con dudas sobre el avance.',
  after: 'Cerrar cada consulta con un insight claro y un siguiente paso definido.'
}];
export function ComparisonSection() {
  return <section className="bg-[#faf6fb] px-4 py-14" data-id="element-45" data-mp="jpyope2any8w">
      <div className="mx-auto max-w-md text-center" data-id="element-46" data-mp="3afcpy5ub8st5">
        <h2 className="font-display text-3xl font-bold leading-tight text-plum" data-id="element-47" data-mp="3adt9ae4qsfqu">
          De improvisar… a conducir cada sesión con seguridad.
        </h2>

        <div className="mt-8 space-y-4" data-id="element-48" data-mp="30hq93dtgar6j">
          {rows.map((row, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.05
        }} className="overflow-hidden rounded-2xl border border-rose-100 bg-white shadow-sm" data-id="element-49" data-mp="35g01jgnsjdog" data-mpi={i}>
              <div className="flex items-start gap-3 border-b border-rose-100 bg-rose-50/60 p-4 text-left" data-id="element-50" data-mp="3jerdawf6kn9f">
                <span className="mt-0.5 flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-rose-200" data-id="element-51" data-mp="3odkscta48mbp">
                  <XIcon className="h-4 w-4 text-rose-600" data-id="element-52" data-mp="fwzh15u0hh5f" />
                </span>
                <div data-id="element-53" data-mp="krdfxi7vu6eu">
                  <p className="text-[11px] font-bold uppercase tracking-wider text-rose-500" data-id="element-54" data-mp="krlv5grh9nt7">
                    Antes
                  </p>
                  <p className="mt-0.5 text-sm text-plum/70" data-id="element-55" data-mp="pmeum20320sq">{row.before}</p>
                </div>
              </div>
              <div className="flex justify-center py-1" data-id="element-56" data-mp="kmaam1zyunxr">
                <ArrowDownIcon className="h-4 w-4 text-magenta" data-id="element-57" data-mp="gm9wyjkoygrr" />
              </div>
              <div className="flex items-start gap-3 bg-emerald-50/60 p-4 text-left" data-id="element-58" data-mp="gocoj81hshyl">
                <span className="mt-0.5 flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-emerald-200" data-id="element-59" data-mp="bp00ijyvx4uf">
                  <CheckIcon className="h-4 w-4 text-emerald-700" data-id="element-60" data-mp="1wu8xbcjopfr" />
                </span>
                <div data-id="element-61" data-mp="3t3ewum7azh8k">
                  <p className="text-[11px] font-bold uppercase tracking-wider text-emerald-600" data-id="element-62" data-mp="3t3wxdv100hma">
                    Después del Oráculo
                  </p>
                  <p className="mt-0.5 text-sm font-medium text-plum" data-id="element-63" data-mp="3p3wdhuv4re7u">{row.after}</p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}